import React from "react";
import { connect } from "react-redux";
import { Portlet, PortletBody, } from "../../partials/content/Portlet";
import ContractParties from "../../widgets/ContractParties";
import ContractPayments from "../../widgets/ContractPayments";
import ContractActions from "../../widgets/ContractActions";
import ContractTimeline from "../../widgets/ContractTimeline";
import ProgramTimeline from "../../widgets/ProgramTimeline";
import ContractPrice from "../../widgets/ContractPrice";
import DonutCharts from "../../widgets/DonutCharts";
import ConrtractCalendarAction from "../../widgets/ConrtractCalendarAction";
import PortletSpinner from '../../partials/layout/PortletSpinner';
import Common from '../../shared/common';


class Dashboard extends React.Component {


  render() {
    if (!this.props.contractDashboard || !this.props.contractTemplate) {
      return (<PortletSpinner />);
    }
    const { contract } = this.props;

    return (
      <>
        <Portlet style={{ marginBottom: 20 }}>
          <PortletBody >
            <p
              style={{
                fontSize: "1.1rem",
                margin: 0,
                fontWeight: 500,
                color: "#3F96C4"
              }}
            >
              {contract.name}
            </p>
          </PortletBody>
        </Portlet>

        <Portlet style={{ marginBottom: 20 }}>

          <PortletBody fit={true}>
            <div className="row row-no-padding row-col-separator-md">
              <div className="col-md-4">
                <ContractParties
                  userProfile={this.props.userProfile}
                  contract={this.props.contract}
                  contractTemplate={this.props.contractTemplate}
                  contractUsers={this.props.contractUsers}
                />
              </div>
              <div className="col-md-4">
                <ContractPrice
                  contract={this.props.contract}
                  contractDashboard={this.props.contractDashboard}
                  contractTemplate={this.props.contractTemplate}
                  dashboardCurrencyCode={this.props.dashboardCurrencyCode}
                />
              </div>
              <div className="col-md-4">
                <ContractTimeline
                  contractTemplate={this.props.contractTemplate}
                  contractid={this.props.contract.contractid}
                  startdate={this.props.contract.startdate}
                  enddate={this.props.contract.completedate}
                  currentenddate={this.props.contract.completiondate}
                  actualcompletiondate={this.props.contract.actualcompletiondate}
                  defectsdate={this.props.contract.defectsdate}
                  globalResources={this.props.contractTemplate.resources}
                />
              </div>
            </div>
          </PortletBody>
        </Portlet>
        <Portlet style={{ marginBottom: 20 }}>
          <PortletBody fit={true}>
            <div className="row row-no-padding row-col-separator-md">
              <div className="col-md-4">
                <ProgramTimeline
                  contractid={this.props.contract.contractid}
                  contractTemplate={this.props.contractTemplate}
                  // supplierName={this.props.contractTemplate.resources.SUPPLIER_NAME}
                  expectedcompletiondate={this.props.contract.expectedcompletiondate}
                  dashboard={this.props.contractDashboard}
                />
              </div>
              <div className="col-md-4">
                <ContractPayments
                  contract={this.props.contract}
                  globalResources={this.props.contractTemplate.resources}
                  dashboardCurrencyCode={this.props.dashboardCurrencyCode}
                />
              </div>
              <div className="col-md-4">
                <ContractActions
                  contractid={this.props.contract.contractid}
                  contract={this.props.contract}
                  contractDashboard={this.props.contractDashboard}
                  contractTemplate={this.props.contractTemplate}
                  actions={this.props.actions}
                />
              </div>
            </div>
          </PortletBody>
        </Portlet>
        <div className="row">
          <div className="col-xl-6">
            <DonutCharts
              contractid={this.props.contract.contractid}
              globalResources={this.props.contractTemplate.resources}
              workflowsQA={this.props.contractTemplate.workflowsQA}
              dashboard={this.props.contractDashboard}
              contractTemplate={this.props.contractTemplate}
            />
          </div>
          <div className="col-xl-6">
            <Portlet fluidHeight={true} style={{ marginBottom: 20 }}>
              {/* <PortletHeader title="Deadline Calendar" /> */}
              <PortletBody>
                <ConrtractCalendarAction
                  lang={this.props.lang}
                  contract={this.props.contract}
                  manualActions={this.props.actions}
                  contractTemplate={this.props.contractTemplate}
                />

              </PortletBody>
            </Portlet>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = store => ({
  contract: store.contract.contract,
  contractTemplate: store.contract.template,
  contractDashboard: store.contract.dashboard,
  dashboardCurrencyCode: store.contract.dashboardCurrencyCode,
  userProfile: store.auth.userProfile,
  contractUsers: store.contract.users,
  actions: store.contract.manualActions,
  lang: store.i18n.lang,
});

export default connect(mapStateToProps)(Dashboard);